// extracted by mini-css-extract-plugin
export var chevron = "_jv-4";
export var chevronExpanded = "_jv-5";
export var row = "_jv-0";
export var rowBody = "_jv-6";
export var rowDescription = "_jv-7";
export var rowHeader = "_jv-1";
export var rowTitle = "_jv-2";
export var rowTitleComplete = "_jv-3";